<div [ngClass]="{
      'home-page': pageType === pageTypes.HOME_PAGE,
      'feature-home-page': pageType === pageTypes.FEATURE_HOME_PAGE,
      'list-page': pageType === pageTypes.LIST_PAGE,
      'detail-page': pageType === pageTypes.DETAIL_PAGE,
      'exp-page': featureType === featureTypes.EXPERIENCES,
      'ss-pkg': finalContainer?.feature?.type === featureTypes?.SHORTSTAY_PACKAGE
    }" class="header" id="search-form">
  <div class="search-bar">
    <div class="form-strip">
      @if (formGroup) {
        <div class="search-inner-wrap">
          @if (experienceTabs?.length > 0) {
            <div class="exp-tab flex-container ion-align-items-center ion-justify-content-start">
              @for (tabContainer of experienceTabs; track tabContainer) {
                <div (click)="changeExpTab(tabContainer)"
                     class="tab-name flex-container ion-align-items-center ion-justify-content-center"
                     [ngClass]="{ 'active': finalContainer?.uid === tabContainer?.uid }">
                  {{ tabContainer?.title }}
                </div>
              }
            </div>
          }
          <div class="form-heading">
            @if (finalContainer?.description) {
              <div class="desc">{{ finalContainer?.description }}</div>
            }
          </div>
          <form class="form-container search-form-filter" [formGroup]="formGroup">
            @for (containerItem of finalContainer?.data; track containerItem; let first = $first) {
              @switch (containerItem?.uid) {
                @case (UID_ENUMS.DESTINATION_AUTOCOMPLETE) {
                  <!--<div class="loc-re">
                    <div class="input-box locality list-location" [ngClass]="{ 'left-border-radius': first }"
                         id="locality-popover" (click)="onSelectField(containerItem)">
                      <div class="inp-label">
                      <span class="label-1">{{ containerItem?.label }}
                        <span class="arrow-icon"></span>
                      </span>
                        <input [formControlName]="containerItem?.name"
                               [type]="'hidden'"
                               class="input-field bold-value"
                               readonly=""
                               [placeholder]="(containerItem?.placeholder | titlecase)">
                        <input [formControlName]="containerItem?.name + '_DISPLAY'"
                               [type]="containerItem?.inputType"
                               class="input-field bold-value"
                               readonly=""
                               [placeholder]="(containerItem?.placeholder | titlecase)">
                        <p class="p2 country">India</p>
                        &lt;!&ndash; error block starts &ndash;&gt;
                        @if (formGroup?.get(containerItem?.name + '_DISPLAY')?.touched) {
                          <div>
                            @if (formGroup?.get(containerItem?.name + '_DISPLAY').errors && formGroup?.get(containerItem?.name + '_DISPLAY').errors['required']) {
                              <div
                                class="error-message">
                                <span>This field is required.</span>
                              </div>
                            }
                          </div>
                        }
                        &lt;!&ndash; error block ends &ndash;&gt;
                      </div>
                    </div>
                    <div class="near-loc-wrap" (click)="getCurrentLocation()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" id="near-me">
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path
                          d="M18.75 3.94L4.07 10.08c-.83.35-.81 1.53.02 1.85L9.43 14c.26.1.47.31.57.57l2.06 5.33c.32.84 1.51.86 1.86.03l6.15-14.67c.33-.83-.5-1.66-1.32-1.32z"></path>
                      </svg>
                      <span>Near me</span>
                    </div>
                  </div>-->
                  <div class="localityBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [allowBackdropClose]="true" [width]="'480px'" [top]="'50px'"
                      [background]="'transparent'" [border]="'none'"
                      [componentName]="containerItem?.component"
                      #localityPopover
                    >
                      <div header>
                        <div class="loc-re">
                          <div class="input-box locality list-location" [ngClass]="{ 'left-border-radius': first }"
                               id="locality-popover" (click)="onSelectField(containerItem)">
                            <div class="inp-label">
                            <span class="label-1">{{ containerItem?.label }}
                              <span class="arrow-icon"></span>
                            </span>
                              <input [formControlName]="containerItem?.name"
                                     [type]="'hidden'"
                                     class="input-field bold-value"
                                     readonly=""
                                     [placeholder]="(containerItem?.placeholder | titlecase)">
                              <input [formControlName]="containerItem?.name + '_DISPLAY'"
                                     [type]="containerItem?.inputType"
                                     class="input-field bold-value"
                                     readonly=""
                                     [placeholder]="(containerItem?.placeholder | titlecase)">
                              <p class="p2 country">India</p>
                              <!-- error block starts -->
                              @if (formGroup?.get(containerItem?.name + '_DISPLAY')?.touched) {
                                <div>
                                  @if (formGroup?.get(containerItem?.name + '_DISPLAY').errors && formGroup?.get(containerItem?.name + '_DISPLAY').errors['required']) {
                                    <div
                                      class="error-message">
                                      <span>This field is required.</span>
                                    </div>
                                  }
                                </div>
                              }
                              <!-- error block ends -->
                            </div>
                          </div>
                          <div class="near-loc-wrap" (click)="getCurrentLocation()">
                            <div class="locBox" tapEffect>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                   id="near-me">
                                <path fill="none" d="M0 0h24v24H0V0z"></path>
                                <path
                                  d="M18.75 3.94L4.07 10.08c-.83.35-.81 1.53.02 1.85L9.43 14c.26.1.47.31.57.57l2.06 5.33c.32.84 1.51.86 1.86.03l6.15-14.67c.33-.83-.5-1.66-1.32-1.32z"></path>
                              </svg>
                              <span>Near me</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body class="search-destination">

                          @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                            <div [appLoader]="component" [compData]="selectedCompData"
                                 appB2bDynamicLoader
                                 (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(localityPopover, selectedCompData);"
                            >
                            </div>
                          }

                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>
                  <!--<app-b2b-popover class="locality-popover" trigger="locality-popover" #localityPopover
                                   [componentName]="selectedCompData?.containerItem?.component"
                  >
                    <div popoverContent class="search-destination">
                      @if (selectedCompData?.containerItem?.component) {
                        @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                          <div [appLoader]="component" [compData]="selectedCompData"
                               appB2bDynamicLoader
                               (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(localityPopover, selectedCompData);"
                          >
                          </div>
                        }
                      }
                    </div>
                  </app-b2b-popover>-->
                }
                @case (UID_ENUMS.CHECKIN_DATE_DATEPICKER) {
                  <!-- <div class="input-box checkin-date" id="checkin-date-popover"
                        (click)="onSelectField(containerItem)"
                        [ngClass]="{ 'left-border-radius': first }">
                     <div class="inp-label">
                           <span class="label-1">{{ containerItem?.label }}
                             <span class="arrow-icon"></span>
                           </span>
                       <input
                         id="checkin-date"
                         type="text"
                         class="input-field hide-input"
                         readonly=""
                         value=""
                         [type]="containerItem?.inputType"
                         [formControlName]="containerItem?.name"
                         [placeholder]="(containerItem?.placeholder | titlecase)">
                       @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                         <p class="p1">
                           <span class="bold-value">{{ displayValue?.label1 }}</span>
                           <span class="ml label-2">{{ displayValue?.label2 + ' ' + displayValue?.label3 }}</span>
                         </p>
                         <p class="p2 checkin-date">
                           {{ displayValue?.label4 }}
                         </p>
                       }
                     </div>
                   </div>-->
                    <!--<app-b2b-popover
                      class="checkin-date-popover" #checkinDatePopover
                      trigger="checkin-date-popover"
                    >
                      <div popoverContent class="search-destination">
                        @if (selectedCompData?.containerItem?.component) {
                          @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                            <div [appLoader]="component" [compData]="selectedCompData"
                                 appB2bDynamicLoader
                                 (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(checkinDatePopover, selectedCompData);"
                            >
                            </div>
                          }
                        }
                      </div>
                    </app-b2b-popover>-->
                  <div class="datepickerBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [allowBackdropClose]="true" [top]="'60px'"
                      [left]="'0px'"
                      [background]="'transparent'" [border]="'none'" [boxShadow]="'none'"
                      #checkinDatePopover
                      [componentName]="containerItem?.component"
                    >
                      <div header>
                        <div class="input-box checkin-date" id="checkin-date-popover"
                             (click)="onSelectField(containerItem)"
                             [ngClass]="{ 'left-border-radius': first }">
                          <div class="inp-label">
                          <span class="label-1">{{ containerItem?.label }}
                            <span class="arrow-icon"></span>
                          </span>
                            <input
                              id="checkin-date"
                              type="text"
                              class="input-field hide-input"
                              readonly=""
                              value=""
                              [type]="containerItem?.inputType"
                              [formControlName]="containerItem?.name"
                              [placeholder]="(containerItem?.placeholder | titlecase)">
                            @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                              <p class="p1">
                                <span class="bold-value">{{ displayValue?.label1 }}</span>
                                <span class="ml label-2">{{ displayValue?.label2 + ' ' + displayValue?.label3 }}</span>
                              </p>
                              <p class="p2 checkin-date">
                                {{ displayValue?.label4 }}
                              </p>
                            }
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body class="search-destination">
                          @if (selectedCompData?.containerItem?.component) {
                            @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                              <div [appLoader]="component" [compData]="selectedCompData"
                                   appB2bDynamicLoader
                                   (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(checkinDatePopover,selectedCompData);"
                              >
                              </div>
                            }
                          }
                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>
                }
                @case (UID_ENUMS.CHECKIN_CHECKOUT_DATEPICKER) {
                  <!--<div class="input-box checkin-checkout-date" id="date-range-popover"
                       [ngClass]="{ 'left-border-radius': first }"
                       (click)="onSelectField(containerItem)">
                    <div class="inp-label">
                            <span class="label-1">{{ containerItem?.label }}
                              <span class="arrow-icon"></span>
                            </span>
                      <input id="checkin-checkout-date"
                             type="text"
                             class="input-field hide-input"
                             readonly=""
                             value=""
                             [type]="containerItem?.inputType"
                             [formControlName]="containerItem?.name"
                             [placeholder]="(containerItem?.placeholder | titlecase)"
                      >
                      @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                        <div class="date-sec">
                          <div class="extended">
                            <p class="p1">
                              <span class="bold-value">{{ displayValue?.label1 }}</span>
                              <span class="ml label-2">{{ displayValue?.label2 + ' ' + displayValue?.label3 }}</span>
                            </p>
                            <p class="p2 checkin-date">
                              {{ displayValue?.label4 }}
                            </p>
                          </div>
                          <div class="date-range-separator">-</div>
                          <div class="date">
                            <p class="p1">
                              <span class="bold-value">{{ displayValue?.label5 }}</span>
                              <span class="ml label-2">{{ displayValue?.label6 + ' ' + displayValue?.label7 }}</span>
                            </p>
                            <p class="p2 check-in-time">
                              {{ displayValue?.label8 }}
                            </p>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <app-b2b-popover #dateRangePopover class="date-range-popover" trigger="date-range-popover">
                    <div popoverContent>
                      @if (selectedCompData?.containerItem?.component) {
                        @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                          <div [appLoader]="component" [compData]="selectedCompData"
                               appB2bDynamicLoader
                               (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(dateRangePopover, selectedCompData);"
                          >
                          </div>
                        }
                      }
                    </div>
                  </app-b2b-popover>-->

                  <div class="dateRangePickerBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [allowBackdropClose]="true" [top]="'60px'"
                      [left]="'0px'"
                      [background]="'transparent'" [border]="'none'" [boxShadow]="'none'"
                      #dateRangePopover [componentName]="containerItem?.component"
                    >
                      <div header>
                        <div class="input-box checkin-checkout-date" id="date-range-popover"
                             [ngClass]="{ 'left-border-radius': first }"
                             (click)="onSelectField(containerItem)">
                          <div class="inp-label">
                            <span class="label-1">{{ containerItem?.label }}
                              <span class="arrow-icon"></span>
                            </span>
                            <input id="checkin-checkout-date"
                                   type="text"
                                   class="input-field hide-input"
                                   readonly=""
                                   value=""
                                   [type]="containerItem?.inputType"
                                   [formControlName]="containerItem?.name"
                                   [placeholder]="(containerItem?.placeholder | titlecase)"
                            >
                            @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                              <div class="date-sec">
                                <div class="extended">
                                  <p class="p1">
                                    <span class="bold-value">{{ displayValue?.label1 }}</span>
                                    <span
                                      class="ml label-2">{{ displayValue?.label2 + ' ' + displayValue?.label3 }}</span>
                                  </p>
                                  <p class="p2 checkin-date">
                                    {{ displayValue?.label4 }}
                                  </p>
                                </div>
                                <div class="date-range-separator">-</div>
                                <div class="date">
                                  <p class="p1">
                                    <span class="bold-value">{{ displayValue?.label5 }}</span>
                                    <span
                                      class="ml label-2">{{ displayValue?.label6 + ' ' + displayValue?.label7 }}</span>
                                  </p>
                                  <p class="p2 check-in-time">
                                    {{ displayValue?.label8 }}
                                  </p>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body>
                          @if (selectedCompData?.containerItem?.component) {
                            @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                              <div [appLoader]="component" [compData]="selectedCompData"
                                   appB2bDynamicLoader
                                   (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(dateRangePopover, selectedCompData);"
                              >
                              </div>
                            }
                          }
                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>
                }
                @case (UID_ENUMS.CHECKIN_TIME) {
                  <!--<div class="input-box checkin-time" id="checkin-time-popover"
                       [ngClass]="{ 'left-border-radius': first }"
                       (click)="onSelectField(containerItem)">
                    <div class="inp-label">
                              <span class="label-1">{{ containerItem?.label }}
                                <span class="arrow-icon"></span>
                              </span>
                      <input id="checkin-time"
                             type="text"
                             class="input-field hide-input"
                             readonly=""
                             [type]="containerItem?.inputType"
                             [formControlName]="containerItem?.name"
                             [placeholder]="(containerItem?.placeholder | titlecase)"
                      >
                      @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                        @if (displayValue?.label1) {
                          <p class="p1">
                            <span class="bold-value">{{ displayValue?.label1 }}</span>
                            @if (displayValue?.label2) {
                              <span class="ml label-2">{{ displayValue?.label2 }}</span>
                            }
                          </p>
                        }
                        @if (displayValue?.label2) {
                          <p class="p2 check-in-time">
                            {{ displayValue?.label2 }}
                          </p>
                        }
                      }
                    </div>
                  </div>
                  <app-b2b-popover
                    class="checkin-time-popover" #checkinTimePopover
                    trigger="checkin-time-popover"
                  >
                    <div popoverContent class="checkin-sdw">
                      @if (selectedCompData?.containerItem?.component) {
                        @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                          <div [appLoader]="component" [compData]="selectedCompData"
                               appB2bDynamicLoader
                               (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(checkinTimePopover, selectedCompData);"
                          >
                          </div>
                        }
                      }
                    </div>
                  </app-b2b-popover>-->
                  <div class="checkinBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [top]="'60px'" [left]="'0px'" [width]="'400px'"
                      [background]="'transparent'" [border]="'none'" [allowBackdropClose]="true"
                      [componentName]="containerItem?.component"
                      #checkinTimePopover>
                      <div header>
                        <div class="input-box checkin-time" id="checkin-time-popover"
                             [ngClass]="{ 'left-border-radius': first }"
                             (click)="onSelectField(containerItem)">
                          <div class="inp-label">
                          <span class="label-1">{{ containerItem?.label }}
                            <span class="arrow-icon"></span>
                          </span>
                            <input id="checkin-time"
                                   type="text"
                                   class="input-field hide-input"
                                   readonly=""
                                   [type]="containerItem?.inputType"
                                   [formControlName]="containerItem?.name"
                                   [placeholder]="(containerItem?.placeholder | titlecase)"
                            >
                            @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                              @if (displayValue?.label1) {
                                <p class="p1">
                                  <span class="bold-value">{{ displayValue?.label1 }}</span>
                                  @if (displayValue?.label2) {
                                    <span class="ml label-2">{{ displayValue?.label2 }}</span>
                                  }
                                </p>
                              }
                              @if (displayValue?.label2) {
                                <p class="p2 check-in-time">
                                  {{ displayValue?.label2 }}
                                </p>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body class="checkin-sdw">
                          @if (selectedCompData?.containerItem?.component) {
                            @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                              <div [appLoader]="component" [compData]="selectedCompData"
                                   appB2bDynamicLoader
                                   (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(checkinTimePopover, selectedCompData);"
                              >
                              </div>
                            }
                          }
                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>
                }
                @case (UID_ENUMS.HOUR) {
                  <!--<div class="input-box hours" id="hours-popover"
                       [ngClass]="{ 'left-border-radius': first }"
                       (click)="onSelectField(containerItem)">
                    <div class="inp-label">
                                <span class="label-1">{{ containerItem?.label }}
                                  <span class="arrow-icon"></span>
                                </span>
                      <input id="hours"
                             type="text"
                             class="input-field hide-input"
                             readonly=""
                             [type]="containerItem?.inputType"
                             [formControlName]="containerItem?.name"
                             [placeholder]="(containerItem?.placeholder | titlecase)"
                      >
                      @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                        @if (displayValue?.label1) {
                          <p class="p1">
                            <span class="bold-value">{{ displayValue?.label1 }}</span>
                            @if (displayValue?.label2) {
                              <span class="ml label-2">{{ displayValue?.label2 }}</span>
                            }
                          </p>
                        }
                      }
                    </div>
                  </div>
                  <app-b2b-popover class="hours-popover" #hoursPopover trigger="hours-popover">
                    <div popoverContent class="checkin-sdw">
                      @if (selectedCompData?.containerItem?.component) {
                        @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                          <div [appLoader]="component" [compData]="selectedCompData"
                               appB2bDynamicLoader
                               (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(hoursPopover, selectedCompData);"
                          >
                          </div>
                        }
                      }
                    </div>
                  </app-b2b-popover>-->
                  <div class="hourBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [allowBackdropClose]="true" [top]="'60px'"
                      [left]="'0px'"
                      [background]="'transparent'" [width]="'380px'" [border]="'none'"
                      #hoursPopover [componentName]="containerItem?.component"
                    >
                      <div header>
                        <div class="input-box hours" id="hours-popover"
                             [ngClass]="{ 'left-border-radius': first }"
                             (click)="onSelectField(containerItem)">
                          <div class="inp-label">
                                <span class="label-1">{{ containerItem?.label }}
                                  <span class="arrow-icon"></span>
                                </span>
                            <input id="hours"
                                   type="text"
                                   class="input-field hide-input"
                                   readonly=""
                                   [type]="containerItem?.inputType"
                                   [formControlName]="containerItem?.name"
                                   [placeholder]="(containerItem?.placeholder | titlecase)"
                            >
                            @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                              @if (displayValue?.label1) {
                                <p class="p1">
                                  <span class="bold-value">{{ displayValue?.label1 }}</span>
                                  @if (displayValue?.label2) {
                                    <span class="ml label-2">{{ displayValue?.label2 }}</span>
                                  }
                                </p>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body class="checkin-sdw">
                          @if (selectedCompData?.containerItem?.component) {
                            @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                              <div [appLoader]="component" [compData]="selectedCompData"
                                   appB2bDynamicLoader
                                   (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(hoursPopover, selectedCompData);"
                              >
                              </div>
                            }
                          }
                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>

                }
                @case (UID_ENUMS.NEW_ROOM_GUEST_PICKER) {
                  <!--<div class="input-box room-and-guest" id="rooms-and-guests-popover"
                       [ngClass]="{ 'left-border-radius': first }"
                       (click)="onSelectField(containerItem)">
                    <div class="inp-label">
                                  <span class="label-1">{{ containerItem?.label }}
                                    <span class="arrow-icon"></span>
                                  </span>
                      <input id="room-and-guest"
                             type="text"
                             class="input-field hide-input"
                             readonly=""
                             [type]="containerItem?.inputType"
                             [formControlName]="containerItem?.name"
                             [placeholder]="(containerItem?.placeholder | titlecase)"
                      >
                      @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                        <p class="p1">
                          @if (displayValue?.label1) {
                            <span class="bold-value">{{ displayValue?.label1 }}</span>
                          }
                          @if (displayValue?.label2) {
                            <span class="ml mr label-2">{{ displayValue?.label2 }}</span>
                          }
                          @if (displayValue?.label3) {
                            <span class="bold-value">{{ displayValue?.label3 }}</span>
                          }
                          @if (displayValue?.label4) {
                            <span class="ml mr label-2">{{ displayValue?.label4 }}</span>
                          }
                          @if (displayValue?.label5) {
                            <span class="bold-value">{{ displayValue?.label5 }}</span>
                          }
                          @if (displayValue?.label5 && displayValue?.label6) {
                            <span
                              class="ml label-2">{{ displayValue?.label6 }}</span>
                          }
                        </p>
                      }
                    </div>
                  </div>
                  <app-b2b-popover class="rooms-guests-popover" #roomGuestPopover
                                   trigger="rooms-and-guests-popover"
                                   [offsetWidth]="100">
                    <div popoverContent class="checkin-sdw">
                      @if (selectedCompData?.containerItem?.component) {
                        @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                          <div [appLoader]="component" [compData]="selectedCompData"
                               appB2bDynamicLoader
                               (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(roomGuestPopover, selectedCompData);"
                          >
                          </div>
                        }
                      }
                    </div>
                  </app-b2b-popover>-->
                  <div class="guestBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [top]="'60px'" [left]="'0px'"
                      [background]="'transparent'" [width]="'400px'" [border]="'none'"
                      #roomGuestPopover [componentName]="containerItem?.component"
                      [allowBackdropClose]="true"
                    >
                      <div header>
                        <div class="input-box room-and-guest" id="rooms-and-guests-popover"
                             [ngClass]="{ 'left-border-radius': first }"
                             (click)="onSelectField(containerItem)">
                          <div class="inp-label">
                                  <span class="label-1">{{ containerItem?.label }}
                                    <span class="arrow-icon"></span>
                                  </span>
                            <input id="room-and-guest"
                                   type="text"
                                   class="input-field hide-input"
                                   readonly=""
                                   [type]="containerItem?.inputType"
                                   [formControlName]="containerItem?.name"
                                   [placeholder]="(containerItem?.placeholder | titlecase)"
                            >
                            @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                              <p class="p1">
                                @if (displayValue?.label1) {
                                  <span class="bold-value">{{ displayValue?.label1 }}</span>
                                }
                                @if (displayValue?.label2) {
                                  <span class="ml mr label-2">{{ displayValue?.label2 }}</span>
                                }
                                @if (displayValue?.label3) {
                                  <span class="bold-value">{{ displayValue?.label3 }}</span>
                                }
                                @if (displayValue?.label4) {
                                  <span class="ml mr label-2">{{ displayValue?.label4 }}</span>
                                }
                                @if (displayValue?.label5) {
                                  <span class="bold-value">{{ displayValue?.label5 }}</span>
                                }
                                @if (displayValue?.label5 && displayValue?.label6) {
                                  <span
                                    class="ml label-2">{{ displayValue?.label6 }}</span>
                                }
                              </p>
                            }
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body>
                          @if (selectedCompData?.containerItem?.component) {
                            @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                              <div [appLoader]="component" [compData]="selectedCompData"
                                   appB2bDynamicLoader
                                   (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(roomGuestPopover, selectedCompData);"
                              >
                              </div>
                            }
                          }
                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>
                }
                @case (UID_ENUMS.NEW_GUEST_PICKER) {
                  <!--<div class="input-box room-and-guest" id="guests-popover"
                       [ngClass]="{ 'left-border-radius': first }"
                       (click)="onSelectField(containerItem)">
                    <div class="inp-label">
                                  <span class="label-1">{{ containerItem?.label }}
                                    <span class="arrow-icon"></span>
                                  </span>
                      <input id="guest"
                             type="text"
                             class="input-field hide-input"
                             readonly=""
                             [type]="containerItem?.inputType"
                             [formControlName]="containerItem?.name"
                             [placeholder]="(containerItem?.placeholder | titlecase)"
                      >
                      @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                        <p class="p1">
                          @if (displayValue?.label1) {
                            <span class="bold-value">{{ displayValue?.label1 }}</span>
                          }
                          @if (displayValue?.label2) {
                            <span class="ml mr label-2">{{ displayValue?.label2 }}</span>
                          }
                          @if (displayValue?.label3) {
                            <span class="bold-value">{{ displayValue?.label3 }}</span>
                          }
                          @if (displayValue?.label4) {
                            <span class="ml mr label-2">{{ displayValue?.label4 }}</span>
                          }
                          @if (displayValue?.label5) {
                            <span class="bold-value">{{ displayValue?.label5 }}</span>
                          }
                          @if (displayValue?.label5 && displayValue?.label6) {
                            <span
                              class="ml label-2">{{ displayValue?.label6 }}</span>
                          }
                        </p>
                      }
                    </div>
                  </div>
                  <app-b2b-popover class="rooms-guests-popover" #roomGuestPopover
                                   trigger="guests-popover"
                                   [offsetWidth]="100">
                    <div popoverContent class="checkin-sdw">
                      @if (selectedCompData?.containerItem?.component) {
                        @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                          <div [appLoader]="component" [compData]="selectedCompData"
                               appB2bDynamicLoader
                               (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(roomGuestPopover, selectedCompData);"
                          >
                          </div>
                        }
                      }
                    </div>
                  </app-b2b-popover>-->
                  <div class="guestBox">
                    <app-b2b-popover-v1
                      [isToggleHeaderClick]="false"
                      [isOpenHeaderClick]="true"
                      [allowContentDrop]="false" [top]="'60px'" [left]="'0px'"
                      [allowBackdropClose]="true"
                      [background]="'transparent'" [width]="'400px'" [border]="'none'"
                      #roomGuestPopover [componentName]="containerItem?.component"
                    >
                      <div header>
                        <div class="input-box room-and-guest" id="guests-popover"
                             [ngClass]="{ 'left-border-radius': first }"
                             (click)="onSelectField(containerItem)">
                          <div class="inp-label">
                                  <span class="label-1">{{ containerItem?.label }}
                                    <span class="arrow-icon"></span>
                                  </span>
                            <input id="guest"
                                   type="text"
                                   class="input-field hide-input"
                                   readonly=""
                                   [type]="containerItem?.inputType"
                                   [formControlName]="containerItem?.name"
                                   [placeholder]="(containerItem?.placeholder | titlecase)"
                            >
                            @if (formGroup?.controls[containerItem?.name + '_DISPLAY']?.value; as displayValue) {
                              <p class="p1">
                                @if (displayValue?.label1) {
                                  <span class="bold-value">{{ displayValue?.label1 }}</span>
                                }
                                @if (displayValue?.label2) {
                                  <span class="ml mr label-2">{{ displayValue?.label2 }}</span>
                                }
                                @if (displayValue?.label3) {
                                  <span class="bold-value">{{ displayValue?.label3 }}</span>
                                }
                                @if (displayValue?.label4) {
                                  <span class="ml mr label-2">{{ displayValue?.label4 }}</span>
                                }
                                @if (displayValue?.label5) {
                                  <span class="bold-value">{{ displayValue?.label5 }}</span>
                                }
                                @if (displayValue?.label5 && displayValue?.label6) {
                                  <span
                                    class="ml label-2">{{ displayValue?.label6 }}</span>
                                }
                              </p>
                            }
                          </div>
                        </div>
                      </div>
                      @if (selectedCompData?.containerItem?.component === containerItem?.component) {
                        <div body class="checkin-sdw">
                          @if (selectedCompData?.containerItem?.component) {
                            @if (((selectedCompData?.containerItem?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                              <div [appLoader]="component" [compData]="selectedCompData"
                                   appB2bDynamicLoader
                                   (dismissEvent)="setFieldValue($event, selectedCompData);dismissPopover(roomGuestPopover, selectedCompData);"
                              >
                              </div>
                            }
                          }
                        </div>
                      }
                    </app-b2b-popover-v1>
                  </div>

                }
              }
            }
            <button class="search-button" (click)="submit()" aria-label="search">
              <!--<span class="search-icon">
              </span>-->
              <!--<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="w-6 h-6 s-ico">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
              </svg>-->

              <span class="text">Search</span>
            </button>
          </form>

          @if (featureType !== featureTypes.EXPERIENCES) {
            <div class="flex-container ion-justify-content-start check-tour"
            >
              <div class="check">
                <input type="checkbox" id="business">
                <label for="business">Business Trip</label>
              </div>
              <div class="check">
                <input type="checkbox" id="leisure">
                <label for="leisure">Leisure Trip</label>
              </div>
            </div>
          }

          @if (experienceTabs?.length > 0) {

            <!-- high lighter text => {{ finalContainer?.highlighterText }}-->

            @if (finalContainer?.highlighterText) {
              <div class="highlighterBox">
                <div class="highlighterImg">
                  <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/info_icon.svg?format=png'"
                       alt="info"
                       width="17" height="17" loading="lazy">
                </div>
                <div class="highlighter">
                  {{ finalContainer?.highlighterText }}
                </div>
              </div>
            }

            <!--enquiryText => {{ finalContainer?.enquiryText }}-->

            @if (finalContainer?.enquiryText) {
              <div class="enquiryBox">
                <div class="enquiryTitle">
                  {{ finalContainer?.enquiryText }}
                </div>
                <div class="enquiryButton">
                  <button class="enquireBtn" (click)="enquriyNow()" tapEffect>Enquire Now!</button>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
